import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import './fileInput.scss';
import Helper from '../../../utilities/helper';
import PropTypes from 'prop-types';
import { getFileExtension } from '../../../utilities/fileHelper';
const MultipleFilesInput = ({
  files,
  setFiles,
  maxSizeFileMB,
  placeholder,
  setFileError,
  fileExtensions
}) => {
  const [isDragging, setDragging] = useState(false);
  const [error, setError] = useState(null);
  const [errorSize, setErrorSize] = useState(null);
  const [errorType, setErrorType] = useState(null);

  useEffect(() => {
   if(files.length > 0){
    validateFiles(files);
   }

  }, []);


  var maxSizeMb = maxSizeFileMB ?? 4;


  const onFileChange = async (event) => {
    var newfiles = Array.from(event.target.files);
    var currentFiles = [...(files || [])];
    for (const file of newfiles) {
      try {
        let fileConverted = await Helper.toBase64(file);
        let extension = file.type.split('/')[1];
        let fileSizeInMb = file.size / 1000000;


        const newFile = {
          id: Helper.genarateUuid4(),
          fileName: file.name,
          fileType: extension,
          fileContentBase64: fileConverted.replace(`data:${file.type};base64,`, ''),
          fileSizeInMb: fileSizeInMb,
        };


        currentFiles.push(newFile);
      } catch (error) {
        console.error('Error processing file:', error);
      }
    }
     validateFiles(currentFiles);
    setFiles(currentFiles);
  }


  const validateFiles = (files) => {
   var errType = files.find(f => !Object.values(fileExtensions).includes(getFileExtension(f.fileType))) ? true : false;
   var allFilesSize = files.reduce((acc, file) => acc + file.fileSizeInMb, 0);
   var errSize = allFilesSize > maxSizeMb;
   setErrorType(errType);
   setErrorSize(errSize);
   setFileError(errType || errSize);
  }

  const removeFile = (fileId) => {
    const currentFiles = files || [];
    const updatedFiles = currentFiles.filter(file => file.id !== fileId);
    setFiles(updatedFiles);
    validateFiles(updatedFiles);
  };

  const removeAllFiles = () => {
    setError(null);
    setFiles([]);
  };


  return (
      <div className="file-input-container">
        <div className="file-input-wrapper">
            <input
             type='file' name='fileInput'
              onChange={onFileChange}
              accept={Object.values(fileExtensions).map(ext => `.${ext}`).join(',')}
              id="fileInput"
              style={{display: 'none'}}
              multiple
              onDragOver={(e) => {
                e.preventDefault();
                setDragging(true);
              }}
              onDragLeave={() => setDragging(false)}
            />
            <div className='file-input-label'> בחירת קובץ להעלאה </div>
            <label
              htmlFor="fileInput"
              className="file-input-btn"
              style={{ cursor: 'pointer' }}

            >
              <Image src={require('../FileInput/icons/upload.svg')} alt="העלאה" /> העלאת מסמכים
            </label>

            {files && files.length > 0 &&(
              <div className="file-details">
                {files.map((file) => (
                  <div key={file.id} className="single-file-upload">
                    <span className="file-name">{file.fileName}</span>
                    <Image src={require('../FileInput/icons/close.svg')}
                      onClick={() => removeFile(file.id)}
                      alt="הסר קובץ" />
                  </div>
                ))}
              </div>
            )}
        </div>

            <div className="bottom-text">
              <div className={errorType ? 'err-msg' : ''}>ניתן לצרף קבצים מסוג: {Object.keys(fileExtensions).join(', ')}</div>
              <div className={errorSize ? 'err-msg' : ''}>גודל הקבצים המרבי הניתן להעלאה הוא {maxSizeMb}MB</div>
            </div>
          {error && <div className="error">{error}</div>}
      </div>
  );
};

const mapDispatchToProps = {
};
const mapStateToProps = (state) => ({
  data: state.businessWorkOrderSystem.bottomBlockData,
});

MultipleFilesInput.propTypes = {
  files: PropTypes.array.isRequired,
  setFiles: PropTypes.func.isRequired,
  maxSizeFileMB: PropTypes.number,
  placeholder: PropTypes.string,
  fileExtensions: PropTypes.object.isRequired,
  setFileError: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultipleFilesInput);
